import client from './client';
import type { StatusEntry } from '../store/useCallStore';

export async function fetchStatuses(): Promise<Record<string, StatusEntry>> {
  const { data } = await client.get<Record<string, StatusEntry>>('/api/status');
  return data;
}

export async function setCallbackStatus(sessionId: string, done: boolean): Promise<void> {
  await client.post(`/api/status/${encodeURIComponent(sessionId)}`, { done });
}

export async function setCallbackNote(sessionId: string, note: string): Promise<void> {
  await client.post(`/api/status/${encodeURIComponent(sessionId)}`, { note });
}
